'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useImageAssetsUrl } from '@marketplace-web/shared/assets'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  icon: string
  title: string
  body: string
}

const FactBlock = ({ icon, title, body }: Props) => {
  const assetUrl = useImageAssetsUrl()

  return (
    <section className="page-section__facts">
      <div className="page-section__fact-single-block">
        <div className="page-section__fact-illustration">
          <Image src={assetUrl(`images/safety/illustrations/${icon}.svg`)} alt="" />
        </div>
        <ResponsiveWrapper
          mobile={<Spacer size={Spacer.Size.XLarge} />}
          desktop={<Spacer size={Spacer.Size.XLarge} orientation={Spacer.Orientation.Vertical} />}
        />
        <div className="page-section__content">
          <Text as="h3">
            <div className="safety_fact-title">{title}</div>
          </Text>
          <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size={Spacer.Size.Large} />} />
          <Text as="span" html>
            <div className="safety_body">{body}</div>
          </Text>
        </div>
      </div>
    </section>
  )
}

export default FactBlock
